import React from "react";
import { LogOut } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { InstallButton } from "@/components/InstallButton";
import { AccountMenu } from "@/components/AccountMenu";
import { useAuth } from "@/context/AuthContext";
import { BottomNav } from "@/components/BottomNav";

export function AppShell({ children, title }) {
  const { t } = useI18n();
  const { logout } = useAuth();

  return (
    <div className="App">
      <div className="relative mx-auto min-h-screen max-w-md border-x border-[#E2EAE5]/60 bg-[#F8FAF8] pb-28 shadow-sm">
        {/* Top bar */}
        <header
          data-testid="app-header"
          className="sticky top-0 z-40 flex items-center justify-between border-b border-[#E2EAE5] bg-[#F8FAF8]/90 px-4 py-3 backdrop-blur-md"
        >
          <div className="flex items-center gap-2.5">
            <img src="/icons/icon-192.png" alt="ESVAN" className="h-8 w-8 rounded-lg" />
            <div className="leading-tight">
              <p className="font-display text-base font-bold text-[#1A2E26]">{title || t("common.appName")}</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <InstallButton />
            <LanguageSwitcher />
            <AccountMenu />
            <button
              data-testid="auth-logout-button"
              onClick={logout}
              className="rounded-full p-2 text-[#4A6358] transition-colors hover:bg-[#F0F4F1] active:scale-95"
              aria-label={t("settings.logout")}
            >
              <LogOut size={18} />
            </button>
          </div>
        </header>

        <main className="esv-fade px-4 pt-4">{children}</main>

        <BottomNav />
      </div>
    </div>
  );
}
